module.exports = __webpack_public_path__ + "static/img/home_product_01_zh.9024e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_01_zh.png
// module id = 2HMu
// module chunks = 34